/**
 * Top page — shop review list hydration (F12).
 *
 * Section `top-reviews.liquid` render 3 card tĩnh (Figma); file này thay bằng
 * 3 review published mới nhất từ Laravel `/api/v1/shop-reviews` (public, port
 * `ps_reviewCnet::getShopReviewForContentPlugin`) qua window.inkApi.
 *
 * Fail-silent: lỗi → giữ fallback tĩnh.
 */
(function () {
  'use strict';

  function whenApiReady(timeoutMs) {
    return new Promise((resolve) => {
      if (window.inkApi) return resolve(window.inkApi);
      const start = Date.now();
      const t = setInterval(() => {
        if (window.inkApi) {
          clearInterval(t);
          resolve(window.inkApi);
        } else if (Date.now() - start > timeoutMs) {
          clearInterval(t);
          resolve(null);
        }
      }, 50);
    });
  }

  function formatDate(unixSeconds) {
    if (!unixSeconds) return '';
    const d = new Date(unixSeconds * 1000);
    return `${String(d.getMonth() + 1).padStart(2, '0')}月${String(d.getDate()).padStart(2, '0')}日`;
  }

  // ★ có nửa sao — band + markup dùng chung `assets/review-stars.js` (bản song sinh
  // của snippet `review-star-band` / getSummaryStar ps_reviewCnet.php:219-245), khớp
  // đúng markup SSR của `review-stars-text` nên AJAX không làm lệch mức sao.
  function starsHtml(score) {
    return window.inkReviewStars ? window.inkReviewStars.html(score) : '';
  }

  function fillCard(card, review) {
    const loc = card.querySelector('[data-ink-review-loc]');
    const date = card.querySelector('[data-ink-review-date]');
    const score = card.querySelector('[data-ink-review-score]');
    const stars = card.querySelector('[data-ink-review-stars]');
    const title = card.querySelector('[data-ink-review-title]');
    const body = card.querySelector('[data-ink-review-body]');
    const order = card.querySelector('[data-ink-review-order]');
    const imgLink = card.querySelector('[data-ink-review-image-link]');
    const img = card.querySelector('[data-ink-review-image]');

    // Chỉ set tên 都道府県 (pref) — markup design giữ "のお客様" tĩnh ngoài span (pref xanh).
    if (loc) loc.textContent = review.pref_name || 'お客様';
    if (date) date.textContent = formatDate(review.cdate);
    const scoreText = Number(review.summary || 0).toFixed(1);
    if (score) score.textContent = scoreText;
    if (stars) stars.innerHTML = starsHtml(review.summary);
    if (title) title.textContent = review.review_title || '';
    if (body) body.textContent = review.review_body || '';
    // 注文回数 từ DB (getDspOrderCnt) — KHÔNG dùng số tĩnh Figma.
    if (order && review.order_count) order.textContent = review.order_count;

    // Ảnh user upload kèm review — chỉ hiện khi review có review_image.
    if (imgLink && img) {
      if (review.review_image) {
        img.src = review.review_image;
        imgLink.href = review.review_image;
        imgLink.hidden = false;
      } else {
        imgLink.hidden = true;
      }
    }
  }

  // Cột phải 購入商品 — điền từ review.purchased_product (đơn 'S' mới nhất của
  // reviewer, đã loại プレゼント品). Không có 商品 → ẩn card: placeholder Figma là
  // sản phẩm KHÔNG phải của review này và không có link.
  function fillPurchasedProduct(card, review) {
    const product = review.purchased_product;
    if (!product) {
      card.hidden = true;
      card.removeAttribute('href');
      return;
    }
    card.hidden = false;

    const img = card.querySelector('[data-ink-review-product-img]');
    const name = card.querySelector('[data-ink-review-product-name]');
    const extra = card.querySelector('[data-ink-review-product-extra]');

    if (product.url) {
      card.href = product.url;
      card.classList.remove('text-ink-black');
      card.classList.add('text-ink-blue');
    }
    if (img && product.image) {
      img.src = product.image;
      img.alt = product.name || '';
    }
    if (name) name.textContent = product.name || '';
    if (extra) extra.textContent = product.other_count > 0 ? `他${product.other_count}点` : '';
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const cards = document.querySelectorAll('[data-ink-review]');
    if (cards.length === 0) return;

    // Hybrid: featured metafield đã render SSR đủ (loc/title/body/score/ảnh/購入/注文回数
    // + summary) → KHÔNG call Laravel. Chỉ AJAX khi SSR thiếu data (marker vắng).
    if (document.querySelector('[data-ink-reviews-ssr]')) return;

    const api = await whenApiReady(3000);
    if (!api) return;

    const res = await api.get('/shop-reviews', { per_page: cards.length });
    const payload = res && res.data;
    const reviews = payload && Array.isArray(payload.data) ? payload.data : [];
    if (reviews.length === 0) return; // giữ fallback tĩnh

    // Aggregate ショップ評価 (điểm TB + sao + tổng) từ summary (DB summary table).
    // Fallback paginator.total nếu summary thiếu.
    const summary = res && res.summary;
    const totalCount = summary && summary.count != null ? summary.count : payload.total;
    if (totalCount != null) {
      document.querySelectorAll('[data-ink-review-total]').forEach((el) => {
        el.textContent = Number(totalCount).toLocaleString('ja-JP');
      });
    }
    if (summary && summary.avg_rating != null) {
      const avgText = Number(summary.avg_rating).toFixed(1);
      document.querySelectorAll('[data-ink-review-score-avg]').forEach((el) => {
        el.textContent = avgText;
      });
      document.querySelectorAll('[data-ink-review-stars-avg]').forEach((el) => {
        el.innerHTML = starsHtml(summary.avg_rating);
      });
    }

    // Cột phải 購入商品 là list block song song với voice card (cùng thứ tự review).
    const productCards = document.querySelectorAll('[data-ink-review-product]');

    cards.forEach((card, i) => {
      if (reviews[i]) fillCard(card, reviews[i]);
    });
    productCards.forEach((card, i) => {
      if (reviews[i]) fillPurchasedProduct(card, reviews[i]);
    });
  });
})();
